module.exports = __webpack_public_path__ + "img/5_67.37892a90.png";